import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
/** @jsxImportSource @emotion/react */
import "twin.macro";

import { coupleSidebar, guestSidebar } from "../../settings/paths";
import { COLORS } from "../../lib/styles/styles";
import { MainHeader, Rating, PageLoading } from "..";
import { hideScrollbar } from "../../lib/styles/styleLibrary";
import Auth from "../../lib/middleware/auth";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { switchExperience } from "../../redux/actions/wedding";
import { Wrapper } from "./component";

const MainLayout = (props) => {
	const experience = Auth.getExperience();

	const sideNav = useRef(null);
	const page = useRef(null);
	const [tog, setTog] = useState(true);
	const [showRating, setShowRating] = useState(false);
	const [loading, setLoading] = useState(false);
	const [navList, setNavList] = useState(guestSidebar);

	useEffect(() => {
		if (isEmpty(experience)) {
			return;
		}
		experience === "guest"
			? setNavList(guestSidebar)
			: setNavList(coupleSidebar);
	}, [experience]);

	const showSideNav = () => {
		if (sideNav.current && page.current) {
			sideNav.current.style.width = "250px";
			page.current.style.marginLeft = "250px";
			setTog(false);
		}
	};

	const hideSideNav = () => {
		if (window.innerWidth < 1124) {
			if (sideNav.current && page.current) {
				sideNav.current.style.width = "0px";
				page.current.style.marginLeft = "0px";
				setTog(true);
			}
		}
	};

	const handleSwitchExperience = async () => {
		const data = {
			experience: experience === "guest" ? "couple" : "guest",
		};
		setLoading(true);
		try {
			const res = await switchExperience(data);
			// console.log(res, "from  switch");
			const { hasError } = res.data;
			if (hasError) {
				return;
			}
			experience === "guest"
				? setNavList(coupleSidebar)
				: setNavList(guestSidebar);
			setTimeout(() => {
				window.location.reload(false);
			}, 100);
		} catch (error) {
		} finally {
			setLoading(true);
		}
	};

	return (
		<Wrapper>
			<MainHeader toggle={() => (tog ? showSideNav : hideSideNav)} />
			{/* sidebar */}
			<div ref={sideNav} className="side">
				<div
					className="inner-cont"
					tw="h-full overflow-x-hidden overflow-y-auto flex flex-col gap-3"
					css={hideScrollbar}>
					{navList.map((nav) => {
						if (nav.name === "Join a wedding") {
							return (
								<div key={nav.name}>
									<hr tw="w-full opacity-20 mt-4" />
									<div
										key={nav.name}
										to={"#"}
										onClick={handleSwitchExperience}
										tw="w-full text-appTextDark px-3 py-3 md:px-6  inline-flex items-center text-xs md:text-sm hover:(transition-colors ease-in duration-500 text-appPink cursor-pointer)">
										{nav.icon} {nav.name}
									</div>
								</div>
							);
						}
						if (nav.name === "Create a wedding") {
							return (
								<div key={nav.name}>
									<hr tw="w-full opacity-20" />
									<div
										key={nav.name}
										to={"#"}
										onClick={handleSwitchExperience}
										tw="w-full text-appTextDark px-3 py-3 md:px-6  inline-flex items-center text-xs md:text-sm hover:(transition-colors ease-in duration-500 text-appPink cursor-pointer)">
										{nav.icon} {nav.name}
									</div>
								</div>
							);
						}

						if (nav.name === "Rate Us") {
							return (
								<div
									key={nav.name}
									onClick={() => {
										setShowRating(true);
									}}>
									<hr tw="w-full opacity-20 mt-12" />
									<div
										key={nav.name}
										to={nav.path}
										tw="w-full text-appTextDark px-3 py-3 md:px-6  inline-flex items-center text-xs md:text-sm hover:(transition-colors ease-in duration-500 text-appPink)"
										// activeStyle={{
										// 	border: `1px solid ${COLORS.appPink}`,
										// 	borderRadius: "0px 20px 20px 0px",
										// 	borderLeft: "none",
										// 	background: "#fff !important",
										// }}
										>
										{nav.icon} {nav.name}
									</div>
								</div>
							);
						}
						if (nav.name === "Plan a wedding (planner)") {
							return (
								<div key={nav.name}>
									<hr tw="w-full opacity-20" />
									<div
										key={nav.name}
										onClick={() => {
											Toast.fire({
												icon: "question",
												title: "Feature coming soon...",
											});
										}}
										// to={nav.path}
										tw="w-full text-appTextDark px-3 py-3 md:px-6  inline-flex items-center text-xs md:text-sm hover:(transition-colors ease-in duration-500 text-appPink)"
										// activeStyle={{
										// 	border: `1px solid ${COLORS.appPink}`,
										// 	borderRadius: "0px 20px 20px 0px",
										// 	borderLeft: "none",
										// 	background: "#fff !important",
										// }}
										>
										{nav.icon} {nav.name}
									</div>
								</div>
							);
						}

						return (
							<NavLink
								key={nav.name}
								to={nav.path}
								tw="text-appTextDark px-3 py-3 md:px-6  inline-flex items-center text-xs md:text-sm hover:(transition-colors ease-in duration-500 text-appPink)"
								activeStyle={{
									border: `1px solid ${COLORS.appPink}`,
									borderRadius: "0px 20px 20px 0px",
									borderLeft: "none",
									background: "#fff !important",
									color: `${COLORS.appPinkSaturated}`,
								}}>
								{nav.icon} {nav.name}
							</NavLink>
						);
					})}
				</div>
			</div>

			{/* main page */}
			<div ref={page} className="page">
				{loading && <PageLoading />}
				{props.children}
			</div>
			<Rating showRating={showRating} setShowRating={setShowRating} />
		</Wrapper>
	);
};
export default MainLayout;
